import styled from 'styled-components';

export const ForgotLoginLink = styled.div`
  text-align: center;
  color: var(--color-detached);
  margin-bottom: var(--spacing-regular);
  cursor: pointer;
  font-size: var(--font-paragraph);
`;
